import styled from '@emotion/styled'
import { UserSettingsLinkProps } from './UserSettingsLink'
import { tokens } from '@news-mono/design-tokens'

// TheNightly Colors
const tnColors = tokens.thenightly.colors
const tnPalette = tnColors.palette

const { pinkGarnet } = tokens.perthnow.colors.palette

interface StyledUserSettingsLinkProps extends UserSettingsLinkProps {}

export const StyledUserSettingsLink = styled('a')<StyledUserSettingsLinkProps>(
    ({
        color = tnPalette.section.opinion.default,
        display,
        fontWeight,
        disabled,
        marginBottom,
        width,
        underline = true,
        margin,
        theme,
        textTransform,
    }) => [
        {
            color: disabled ? tnPalette.neutral[50] : color,
            display,
            fontWeight,
            textUnderlinePosition: 'under',
            cursor: disabled ? 'no-drop' : 'pointer',
            textDecoration: underline ? 'underline' : 'none',
            margin: margin ?? undefined,
            marginBottom: marginBottom ?? undefined,
            width: width ?? undefined,
            textTransform: textTransform ?? 'none',
        },
        // PerthNow Styling
        theme.kind === 'perthnow' && {
            textTransform: textTransform ?? 'none',
            fontFamily: theme.fonts.sansSerif,

            '&:active, &:hover, &:focus': {
                color: disabled ? tnPalette.neutral[70] : pinkGarnet,
            },
        },
    ],
)
